import React from 'react';
import { Button, Card, Flex, Modal, message } from 'antd';
import { EditOutlined, EllipsisOutlined, SettingOutlined, QrcodeOutlined, LinkOutlined } from '@ant-design/icons';
import CardContent from './card-content';
import { openWxminiShop } from './tools';

export default ({content = {}}) => {
    const imageUrlPrefix = '//img.yxdj.tech/';
    const {
        shopId,
        accId,
        title,
        logoUrl,
        shopType,
        status,
        wxQrcodeUrl,
        contactPhoneNo,
        description,
        isHead,
    } = content;

    const CardHeader = () => {
        return (
            <Flex justify="space-between">
                <Flex gap={10}>
                    <img style={{width: 30, height: 30}} src={`${imageUrlPrefix}${logoUrl}?x-oss-process=image/resize,w_200`} alt="logo" />
                    <div style={{maxWidth: '225px', overflow: 'hidden', textOverflow: 'ellipsis'}}>{title || '默认店铺'}{isHead && '(总店)'}</div>
                </Flex>
                <Flex gap={10} align='center'>
                    <div onClick={() => onQrcodeClick(shopId)}><QrcodeOutlined /></div>
                    <a onClick={() => onWxminiUrlClick(shopId)}><LinkOutlined /></a>
                </Flex>
            </Flex>
        )
    }

    const getQrcode = async (shopId) => {
        const response = await fetch(`/api/shop/qrcode?shopId=${shopId}`);
        const result = await response.json();

        if(result.success) {
            // setQrcode(result.data);
            // setIsQrcodeOpen(true);
            return result.data;
        } else {
            message.error(result.data);
        }
    }

    const updateQrcode = async (shopId) => { 
        const data = await getQrcode(shopId);

        const response = await fetch(`/api/shop/edit?shopId=${shopId}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                wxQrcodeUrl: data.url
            })
        });

        const result = await response.json();

        if(result && result.success) {
            message.success('更新成功');
            window.location.reload();
        } else {
            message.error(result.data);
        }
    };

    const onQrcodeClick = async (shopId) => {
        // const wxQrcodeUrl  = await getQrcode(shopId);
        // console.log(wxQrcodeUrl);
        Modal.info({
            icon: null,
            title: '二维码',
            content: <div style={{ textAlign: 'center'}}>
                <img width={120} src={`${imageUrlPrefix}${wxQrcodeUrl}`} />
                <div style={{textAlign: 'center'}}><Button onClick={() => updateQrcode(shopId)}>更新二维码</Button></div>
            </div>
        });
    };

    const onWxminiUrlClick = async () => {
        await openWxminiShop(accId, shopId)
    }

    const requestDelete = async (shopId) => {
        const response = await fetch(`/api/shop/del`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                shopId,
            }),
        });
        const result = await response.json();
        if(result.success) {
            message.success('删除成功');
        } else {
            message.error(result.data);
        }

        return result;
    }

    const onDelete = async (shopId) => {
        Modal.confirm({
            title: '确定删除该店铺？',
            content: '删除后将无法恢复',
            onOk: () => {
                requestDelete(shopId).then(result => {
                    
                })
            }
        });
    }

    return (
        <Card title={<CardHeader />} style={{minWidth: 360, maxWidth: 456, width: '100%'}}
            actions={[
                <a href={`/shop/create?accId=${accId}&shopId=${shopId}`}><EditOutlined key="edit" /> 编辑</a>,
                // <a href=""><SettingOutlined key="setting" /> 禁用</a>,
                <div onClick={() => onDelete(shopId)}><EllipsisOutlined key="ellipsis"  /> 删除</div>,
            ]}
        >
            <CardContent content={content} />
        </Card>
    )
}